<template lang="">
    <div class="company-container">
		<img class="pointer" src="https://wenwu3.oss-cn-hangzhou.aliyuncs.com/company/wap/01.jpg">
		<img class="pointer" src="https://wenwu3.oss-cn-hangzhou.aliyuncs.com/company/wap/02.jpg">
		<img class="pointer" src="https://wenwu3.oss-cn-hangzhou.aliyuncs.com/company/wap/03.jpg">
		<img class="pointer" src="https://wenwu3.oss-cn-hangzhou.aliyuncs.com/company/wap/04.jpg">
		<img class="pointer" src="https://wenwu3.oss-cn-hangzhou.aliyuncs.com/company/wap/05.jpg">
		<img class="pointer" src="https://wenwu3.oss-cn-hangzhou.aliyuncs.com/company/wap/05_1.jpg">
		<img class="pointer" src="https://wenwu3.oss-cn-hangzhou.aliyuncs.com/company/wap/06.jpg">
		<img class="pointer" src="https://wenwu3.oss-cn-hangzhou.aliyuncs.com/company/wap/07.jpg">
		<img class="pointer" src="https://wenwu3.oss-cn-hangzhou.aliyuncs.com/company/wap/08.jpg">
        <van-swipe class="my-swipe" :autoplay="2500" indicator-color="white">
            <van-swipe-item v-for="(image, index) in images" :key="index">
                <img :src="image" />
            </van-swipe-item>
        </van-swipe>
    </div>
    
</template>
<script>
export default {
    data() {
        return {
            images: [
                'https://wenwu3.oss-cn-hangzhou.aliyuncs.com/company/wap/09_1.jpg',
                'https://wenwu3.oss-cn-hangzhou.aliyuncs.com/company/wap/09_2.jpg',
                'https://wenwu3.oss-cn-hangzhou.aliyuncs.com/company/wap/09_3.jpg',
            ],            
        }
    },
}
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
    .company-container {
        width: 100%;
        padding-bottom: 48px;
    }
    .company-container img {
        width: 100%;
        height: auto;
        display: block;
    }

</style>